module.exports = __webpack_public_path__ + "img/nodata.99c5264b.svg";